import React from 'react'
import PropTypes from 'prop-types'
import { Spacing50 } from 'styles/sharedStyle'
import MarkdownRenderer from 'components/MarkdownRenderer'
import { bambuserChannelScript } from 'utils/bambuserScripts'
import BambuserWrapper from './Bambuser.style'

const Bambuser = ({ channelId, nodeLocale, villageSlug }) => {
  if (!channelId) return null
  const bambuserScript = bambuserChannelScript(
    channelId,
    nodeLocale,
    villageSlug
  )

  return (
    <BambuserWrapper>
      <Spacing50 />
      <MarkdownRenderer html={bambuserScript} />
      <Spacing50 />
    </BambuserWrapper>
  )
}

Bambuser.propTypes = {
  channelId: PropTypes.string.isRequired,
  nodeLocale: PropTypes.string,
  villageSlug: PropTypes.string,
}

Bambuser.defaultProps = {
  nodeLocale: 'en',
  villageSlug: '',
}

export default Bambuser
